import SchemaViewer from './SchemaViewer';

export default SchemaViewer;
